import React from "react";
import useRoundsButtons from "../../../ViewEvents/Components/KO/useRoundsUtility/useRoundsButtons";
import { Button, Col, DatePicker, Form, Row, TimePicker } from "antd";
import { Formik } from "formik";
import { knockoutScheduleFormValidations } from "../../../../Config/helpers/validations";
import moment from "moment";
import { Info } from "../../../../common/Alerts/Message";

function KnockoutScheduleFormFields({ loading, onFormSubmit, eventData }) {
  const { HistoryButtons } = useRoundsButtons();
  const initialValues = {
    eventId: eventData?._id,
    playhours: "",
    breaktime: "",
    timeforonematch: "",
    startfirstmatch: ""
  };

  return (
    <div style={{ maxWidth: "100%" }}>
      <h1 className="ceheading">Event Scheduling</h1>
      <HistoryButtons origin={"schedule"} loading={loading} />
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={knockoutScheduleFormValidations}
        onSubmit={onFormSubmit}>
        {({ values, errors, isValid, dirty, setFieldValue, handleSubmit }) => (
          <div className="formorganizer">
            <Form
              name="basic"
              onFinish={handleSubmit}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              initialValues={{ remember: true }}
              autoComplete="off">
              <Row>
                <Col lg={12} md={24} className="ceinputformpadding">
                  <label className="boldlabel" style={{ fontSize: "17px" }}>
                    Number of play hours each day
                  </label>
                  <br />
                  <Form.Item
                    className="mt-2"
                    required={true}
                    help={errors?.playhours ? errors?.playhours : undefined}
                    validateStatus={errors?.playhours ? "error" : "success"}>
                    <TimePicker
                      name="playhours"
                      onChange={(_, timeString) => setFieldValue("playhours", timeString)}
                      defaultValue={moment("00:00:00", "HH:mm")}
                      format={"HH:mm"}
                    />
                  </Form.Item>

                  <br />

                  <label className="boldlabel" style={{ fontSize: "17px" }}>
                    Break between each match
                  </label>
                  <br />
                  <Form.Item
                    className="mt-2"
                    required={true}
                    help={errors?.breaktime ? errors?.breaktime : undefined}
                    validateStatus={errors?.breaktime ? "error" : "success"}>
                    <TimePicker
                      name="breaktime"
                      onChange={(_, timeString) => setFieldValue("breaktime", timeString)}
                      defaultValue={moment("00:00:00", "HH:mm")}
                      format={"HH:mm"}
                    />
                  </Form.Item>
                </Col>
                <Col lg={12} md={24} className="ceinputformpadding">
                  {/* PARALLET MATCHES */}
                  {/* <div>
                    <label className="boldlabel" style={{ fontSize: "17px" }}>
                      Do you want parallel matches?
                      <Switch
                        name="wantParallelMatches"
                        style={{ marginLeft: "5px" }}
                        checked={values?.wantParallelMatches}
                        onChange={async (checked) => {
                          await setFieldValue("wantParallelMatches", checked);
                          if (!checked) {
                            await setFieldValue("parallel", "");
                          }
                        }}
                      />
                    </label>
                    <Form.Item
                      required={true}
                      help={errors?.parallel ? errors?.parallel : undefined}
                      validateStatus={errors?.parallel ? "error" : "success"}
                      style={{ display: values?.wantParallelMatches ? "block" : "none" }}
                      className="profileItems">
                      <Select
                        className="ceinputfieldnos selectSmall"
                        title="parallel"
                        value={values?.parallel}
                        bordered={true}
                        name="parallel"
                        onSelect={(e) => setFieldValue("parallel", e)}>
                        {Array(10)
                          .fill(null)
                          .map((_, i) => (
                            <Option value={i + 1} key={`parallel${i}`}>
                              {i + 1}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </div> */}
                  <Form.Item
                    className="profileItems mt-3"
                    required={true}
                    help={errors?.startfirstmatch ? errors?.startfirstmatch : undefined}
                    validateStatus={errors?.startfirstmatch ? "error" : "success"}>
                    <label className="boldlabel">Starting Time of First Match</label>
                    <DatePicker
                      name="startfirstmatch"
                      disabledDate={(current) => {
                        return (
                          current < moment(eventData?.startDate).startOf("day") ||
                          current > moment(eventData?.endDate).startOf("day") ||
                          current < moment().startOf("day")
                        );
                      }}
                      format="YYYY-MM-DD HH:mm:ss"
                      onChange={(e, dateString) => setFieldValue("startfirstmatch", dateString)}
                    />
                  </Form.Item>

                  <Form.Item
                    className="halfwidth profileItems"
                    required={true}
                    help={errors?.timeforonematch ? errors?.timeforonematch : undefined}
                    validateStatus={errors?.timeforonematch ? "error" : "success"}>
                    <label className="boldlabel">Time Required for one Match</label>
                    <TimePicker
                      format={"HH:mm"}
                      showNow={false}
                      inputReadOnly
                      value={
                        values?.timeforonematch
                          ? moment(values?.timeforonematch, "HH:mm")
                          : undefined
                      }
                      className="mt8"
                      onChange={(e, i) => {
                        let a = String(i).split(":");
                        if (a[0] === "00" && a[1] === "00") {
                          Info("Time can't be 00:00");
                          setFieldValue("timeforonematch", "");
                        } else setFieldValue("timeforonematch", i);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Button
                  disabled={loading || !isValid || !dirty}
                  loading={loading}
                  type="primary"
                  htmlType="submit">
                  Schedule
                </Button>
              </Row>
            </Form>
          </div>
        )}
      </Formik>
    </div>
  );
}

export default KnockoutScheduleFormFields;
